import React from 'react';
import Skeleton from 'flow/components/ui-components/Skeleton';

export const MessageFileSkeleton = () => (
    <Skeleton>
        <div className="flex h-13 w-full items-center justify-items-start gap-x-3 p-2">
            <Skeleton.Icon className="size-4.5" />
            <div className="flex-1">
                <Skeleton.Text className="w-3/4" />
            </div>
            <Skeleton.Text className="w-12" />
        </div>
    </Skeleton>
);
